import React from 'react';
import {useTheme} from '@mui/material';
import type {ThesaurusId} from 'services/thesaurus/types';
import {Card} from 'components/card';
import {Layout} from 'components/layout';
import {Spacer} from 'components/spacer';
import {TopLevels} from './TopLevels';
import {TopLevelsGuide} from './TopLevelsGuide';

type Props = {
  thesaurusId: ThesaurusId;
};
export const TopLevelsContainer: React.FC<Props> = ({thesaurusId}) => {
  const {colors} = useTheme();
  return (
    <Layout horizontal flex={1}>
      <Card colorx={colors.offWhite} scrollable flex={1}>
        <Card.Content>
          <TopLevels />
        </Card.Content>
      </Card>
      <Spacer size={2} />

      <TopLevelsGuide thesaurusId={thesaurusId} />
    </Layout>
  );
};
